import { __ } from '@wordpress/i18n';
import {
	TextControl,
} from '@wordpress/components';
import { decodeEntities } from '@wordpress/html-entities';
import ColorControl from '../../../controls/ColorControl';
const Skills = ({ item, index, itemIndex, handleChangeItemField, setAttributes, attributes }) => {
	const {
		skillNameColor,
		skillPercentageColor,
		skillProgressTopColor,
		skillProgressBottomColor,
		style,
	} = attributes || {};
	return (
		<>
			
			<TextControl
				label={__('Skill Name', 'cv-builder')}
				value={decodeEntities(item.name || '')}
				onChange={(value) =>
					handleChangeItemField(value, index, itemIndex, 'name')
				}
			/>
			{item.percentage !== undefined && (
				<TextControl
					label={__('Skill Percentage', 'cv-builder')}
					value={item.percentage || 0}
					type="number"
					min={0}
					max={100}
					step={1}
					onChange={(value) => handleChangeItemField( Number(value), index, itemIndex, 'percentage' ) }
				/>
			)}
			{
				style !== 'style26' && style !== 'style27' && style !== 'style28' && (
					<>
				<ColorControl
					label={__(
				'Skill Name Color',
				'cv-builder'
				)}
				color={skillNameColor}
				colorName="skillNameColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Skill Percentage Color',
				'cv-builder'
				)}
				color={skillPercentageColor}
				colorName="skillPercentageColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Progress Top Background Color',
				'cv-builder'
				)}
				color={skillProgressTopColor}
				colorName="skillProgressTopColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Progress Bottom Background Color',
				'cv-builder'
				)}
				color={skillProgressBottomColor}
				colorName="skillProgressBottomColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			</>
			)
		}
	</>
	);
};

export default Skills;
